import { parseCardsForFeature } from '@/assets/scripts/parsers/cards'

/** returns Cards list
@return { Array }
*/
export const getCardsList = state => {
    return parseCardsForFeature(state.cardsList).map(card => {
        return {
            ...card,
            productName: card.product,
            cardDescription: card.friendlyName.length ? card.friendlyName : null,
            availableBalance: card.accountingBalance,
            cardBalance: card.balance,
            cardCurrency: card.currency
        }
    })
}

/** returns Card Movements
@return { Array }
*/
export const getCardMovements = state => { return state.cardMovements }

/** returns Card Last Movement releaseDatePosition orderNumberPosition info
@return { Object }
*/
export const getLastMovementInfo = state => state.lastMovementInfo

/** returns Card Movements hasMore value
@return { Boolean }
*/
export const getMovementsHasMore = state => state.movementsHasMore
